import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { api } from '@services/api';
import authReducer from '@features/auth/authSlice';
import worksReducer from '@features/works/worksSlice';
import { websocketMiddleware } from './websocketMiddleware';
import { setStoreInstance } from '@services/websocketService';
export const store = configureStore({
    reducer: {
        [api.reducerPath]: api.reducer,
        auth: authReducer,
        works: worksReducer,
        // 其他 reducers 将在后续任务中添加
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            // 忽略这些 action types 的序列化检查
            ignoredActions: ['persist/PERSIST'],
        },
    })
        .concat(api.middleware)
        .concat(websocketMiddleware),
});
// 设置store实例到websocketService，避免循环依赖
setStoreInstance(store);
// 设置监听器以支持 refetchOnFocus/refetchOnReconnect
setupListeners(store.dispatch);
